var _ellipse, _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyRecording(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 117,
    viewBox: "0 0 138 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.5,
    cy: 103.5,
    rx: 44.5,
    ry: 8.5,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103 86V80.0317C103 79.3631 102.777 78.7137 102.365 78.1865L93.76 67.1548C93.1915 66.426 92.3188 66 91.3945 66H42.6055C41.6812 66 40.8085 66.426 40.24 67.1548L31.6346 78.1865C31.2233 78.7137 31 79.3631 31 80.0317V86H54.3239H80.1831H103Z",
    fill: "#AEB8C2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 33,
    width: 50,
    height: 60,
    rx: 2,
    fill: "#F5F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9999 41.834C65.1395 41.834 63.2973 42.2004 61.5786 42.9124C59.8598 43.6243 58.2981 44.6678 56.9826 45.9833C54.3258 48.6401 52.8333 52.2434 52.8333 56.0007C52.8333 59.7579 54.3258 63.3612 56.9826 66.018C58.2981 67.3335 59.8598 68.377 61.5786 69.0889C63.2973 69.8009 65.1395 70.1673 66.9999 70.1673C70.7572 70.1673 74.3605 68.6748 77.0173 66.018C79.674 63.3612 81.1666 59.7579 81.1666 56.0007C81.1666 54.1403 80.8002 52.2981 80.0882 50.5793C79.3763 48.8605 78.3328 47.2988 77.0173 45.9833C75.7018 44.6678 74.14 43.6243 72.4213 42.9124C70.7025 42.2004 68.8603 41.834 66.9999 41.834ZM66.9999 51.7507C68.1271 51.7507 69.2081 52.1984 70.0051 52.9954C70.8022 53.7925 71.2499 54.8735 71.2499 56.0007C71.2499 57.1278 70.8022 58.2088 70.0051 59.0059C69.2081 59.8029 68.1271 60.2507 66.9999 60.2507C65.8727 60.2507 64.7917 59.8029 63.9947 59.0059C63.1977 58.2088 62.7499 57.1278 62.7499 56.0007C62.7499 54.8735 63.1977 53.7925 63.9947 52.9954C64.7917 52.1984 65.8727 51.7507 66.9999 51.7507Z",
    fill: "#DCE0E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 79C31.4477 79 31 79.4477 31 80V103C31 104.657 32.3431 106 34 106H100C101.657 106 103 104.657 103 103V80C103 79.4477 102.552 79 102 79H85.1926C83.9981 79 82.9174 79.7087 82.4412 80.8042L80.9672 84.1958C80.4911 85.2913 79.4104 86 78.2158 86H55.9494C54.9354 86 53.99 85.4878 53.4363 84.6383L50.6482 80.3617C50.0945 79.5122 49.1491 79 48.1351 79H32Z",
    fill: "#DCE0E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRecording);
export default __webpack_public_path__ + "static/media/empty-recording.c7329988fb09b2cbbadac18a597aab7b.svg";
export { ForwardRef as ReactComponent };